import React, { FC } from 'react';
import { Box, Text, TextFieldSize, Select, FormControl } from '@bechtel/gds';
import { useField } from 'formik';
import { useLingui } from '@lingui/react';
import { FillerMaterialSelectorProps } from './types';
import { t } from '@lingui/macro';
import { RodFillerMaterial } from '@bechtel/types';
import { useQuery } from '@apollo/client';
import { GET_ROD_FILLER_MATERIALS } from '@bechtel/client-gql';
import { get } from 'lodash';

const FillerMaterialItem = ({ item }: any) => {
  return (
    <Text size="400" color="grey.1000">
      {item.label}
    </Text>
  );
};

const FillerMaterialSelectedItem = ({ item }: any) => {
  return (
    <Text size="400" color="grey.1000" family="graphik">
      {item.label}
    </Text>
  );
};

export const FillerMaterialSelector: FC<FillerMaterialSelectorProps> = ({ fieldName, onSelect }) => {
  const { i18n } = useLingui();
  const [field, meta, helpers] = useField(fieldName);
  const { setValue } = helpers;
  const { loading, data } =
    useQuery<{
      rodFillerMaterials: RodFillerMaterial[];
    }>(GET_ROD_FILLER_MATERIALS);
  const rodFillerMaterialList: RodFillerMaterial[] = get(data, 'rodFillerMaterials.items', []);
  return (
    <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
      <FormControl label={t`Filler Material`}>
        <Select
          {...field}
          loading={loading}
          selectedItem={field.value}
          itemComponent={FillerMaterialItem}
          selectedComponent={FillerMaterialSelectedItem}
          size={TextFieldSize.LARGE}
          items={rodFillerMaterialList}
          onSelectedItemChange={async (changes) => {
            onSelect(changes.selectedItem);
            setValue(changes.selectedItem);
          }}
          loading={loading}
        />
      </FormControl>
      {meta.touched && meta.error ? (
        <Box pt={{ sm: '200' }}>
          <Text color="bechtel.red">{i18n._(meta.error)}</Text>
        </Box>
      ) : null}
    </Box>
  );
};
